import Layout from "./components/ui/layout";
import MetalFXPage from "./pages/home/page";

const App = () => {
  return (
    <Layout>
      <MetalFXPage />
    </Layout>
  );
};

export default App;
